function getResourceState(state: string, isFeatured: boolean) {
  if (state === 'Pending') {
    return '上架审核中';
  }
  if (state === 'Rejected') {
    return '审核未通过';
  }
  if (state === 'Published') {
    return `审核通过，已上架${isFeatured ? '精选' : ''}`;
  }
  return '';
}

export default getResourceState;
